var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
//------------------------------------------------------------------------------
// Imports
import { Box, InputAdornment, styled, TextField, Tooltip, Typography, useTheme, } from "@mui/material";
import { forwardRef } from "react";
import VTTypography from "./VTTypography";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
//------------------------------------------------------------------------------
// Styling for the dialog window
var StyledTextField = styled(TextField)(function (_a) {
    var theme = _a.theme;
    return ({
        margin: 2,
        borderRadius: "15px",
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderRadius: "15px",
            },
            // "&:hover fieldset": {
            // },
            "&.Mui-error fieldset": {
            // borderColor: darkTheme.palette.mode === "dark" ? theme
            },
        },
        "& .MuiFormHelperText-root": {},
    });
});
var ErrorMessageText = styled(Typography)(function (_a) {
    var theme = _a.theme;
    return ({
        marginLeft: "7px",
        color: theme.palette.mode === "dark" ? theme.palette.error.main : theme.palette.error.dark,
    });
});
export var RequiredInput;
(function (RequiredInput) {
    RequiredInput[RequiredInput["REQUIRED"] = 0] = "REQUIRED";
    RequiredInput[RequiredInput["REQUIRED_ERROR"] = 1] = "REQUIRED_ERROR";
})(RequiredInput || (RequiredInput = {}));
//------------------------------------------------------------------------------
// VTButton use for web development to replace the material ui dialog
export default forwardRef(function VTTextField(_a, ref) {
    // const [val, setValue] = useState<string>(value);
    var autoFocus = _a.autoFocus, _b = _a.controlType, controlType = _b === void 0 ? "controlled" : _b, title = _a.title, name = _a.name, required = _a.required, errorMessage = _a.errorMessage, textFieldLimit = _a.textFieldLimit, infoHint = _a.infoHint, type = _a.type, _c = _a.value, value = _c === void 0 ? "" : _c, id = _a.id, placeholder = _a.placeholder, startIcon = _a.startIcon, endIcon = _a.endIcon, multiline = _a.multiline, rows = _a.rows, disabled = _a.disabled, variant = _a.variant, helperText = _a.helperText, _d = _a.fullWidth, fullWidth = _d === void 0 ? false : _d, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, onKeyDown = _a.onKeyDown, min = _a.min, max = _a.max, sx = _a.sx;
    // useEffect(() => {
    //   setValue(value);
    // }, [value]);
    var theme = useTheme();
    var errorColourForSelectedTheme = theme.palette.mode === "dark" ? theme.palette.error.main : theme.palette.error.dark;
    return (_jsxs(Box, __assign({ component: "div", sx: __assign({}, sx) }, { children: [title && (_jsxs(Box, __assign({ component: "div", sx: {
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "3px",
                } }, { children: [_jsxs(Typography, __assign({ sx: __assign({ display: "inline", marginLeft: "10px" }, (errorMessage && {
                            color: errorColourForSelectedTheme,
                        })) }, { children: [title, required && _jsx("span", __assign({ style: { color: errorColourForSelectedTheme } }, { children: " *" }))] })), infoHint && (_jsx(Tooltip, __assign({ title: infoHint }, { children: _jsx(InfoOutlinedIcon, { sx: { fontSize: "1.4em", marginRight: "7px" } }) })))] }))), _jsx(StyledTextField, { ref: ref, autoFocus: autoFocus, defaultValue: controlType === "non-controlled" ? value : undefined, value: controlType === "controlled" ? value : undefined, name: name, type: type, error: Boolean(errorMessage), onChange: function (input) {
                    // setValue(input.target.value.substring(0, textFieldLimit));
                    onChange && onChange(input.target.value.substring(0, textFieldLimit));
                }, onKeyDown: onKeyDown, placeholder: placeholder && placeholder.toLowerCase(), multiline: multiline, rows: rows, fullWidth: fullWidth, disabled: disabled, onFocus: onFocus, onBlur: onBlur, variant: variant, helperText: "", sx: { width: "100%", marginLeft: "-0.2px" }, InputProps: {
                    startAdornment: _jsx(InputAdornment, __assign({ position: "start" }, { children: startIcon })),
                    endAdornment: _jsx(InputAdornment, __assign({ position: "end" }, { children: endIcon })),
                    inputProps: { max: max, min: min, id: id },
                } }), textFieldLimit && (_jsx(VTTypography, __assign({ type: "Subtitle2", sx: {
                    color: theme.palette.mode === "dark" ? "#a9a9a9" : "#555",
                    marginTop: "3px",
                    marginLeft: "8px",
                } }, { children: "".concat(value ? value.length : 0, "/").concat(textFieldLimit) }))), Boolean(errorMessage) && _jsxs(ErrorMessageText, __assign({ variant: "caption" }, { children: [" ", errorMessage, " "] }))] })));
});
